// extracted by mini-css-extract-plugin
export default {"Tag__name":"Tag_Tag__name__noUUV","spin":"Tag_spin__Iq3L-"};